import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Unlike @see useCallback, returns a stable function reference independent of deps.
 */
export function useEventCallback<T extends (...args: never[]) => unknown>(callback: T): T {
    const ref = useRef<T>(callback);
    useLayoutEffect(() => {
        ref.current = callback;
    });

    return useCallback((...args: Parameters<T>): ReturnType<T> => ref.current(...args) as never, []) as never;
}
